import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgSound = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M15.948 6.186c-.337-.243-.784-.13-.998.253-.214.381-.114.888.223 1.13a4.97 4.97 0 0 1 2.065 3.848 4.94 4.94 0 0 1-2.063 3.834c-.338.241-.439.747-.226 1.13s.66.497.998.255a6.5 6.5 0 0 0 1.957-2.245 6.74 6.74 0 0 0 .78-3.004 6.8 6.8 0 0 0-.78-2.949 6.5 6.5 0 0 0-1.956-2.252m1.049-3.019c.23-.37.681-.457 1.008-.196 1.194.957 2.177 2.215 2.87 3.675A11.8 11.8 0 0 1 22 11.436a11.8 11.8 0 0 1-1.129 4.745c-.696 1.461-1.683 2.718-2.882 3.671-.327.26-.778.17-1.007-.2-.23-.37-.15-.88.176-1.14a8.8 8.8 0 0 0 2.441-3.11 10 10 0 0 0 .955-3.99 10 10 0 0 0-.952-3.99 8.8 8.8 0 0 0-2.432-3.113c-.326-.261-.404-.772-.173-1.142M10.603 2.521c1.108-1.155 2.897-.263 2.897 1.44V20.04c0 1.744-1.86 2.617-2.949 1.384l-4.083-4.015-.002-.002a.26.26 0 0 0-.196-.091H3.727q-.028 0-.056-.003C2.743 17.28 2 16.416 2 15.356V8.293c0-1.08.773-1.956 1.727-1.956h2.566c.07 0 .14-.031.19-.084zM3.77 15.676h2.5c.457 0 .898.206 1.222.575h.001l4.081 4.013c.178.202.481.059.481-.225V3.961c0-.279-.292-.422-.471-.235l-4.12 3.731a1.62 1.62 0 0 1-1.17.517H3.727c-.155 0-.281.143-.281.318v7.065c0 .175.126.318.28.318z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgSound;
